module.exports = __webpack_public_path__ + "static/media/FAQs1.5e9e7be5.png";